import { getGlobalArgs } from '@/root/global';
import { mergeRight } from '@/utils/common';
import { isLocalEnv } from '@/utils/next';
import { COMMON_REQUEST_HEADERS, makeQueryBuilder } from '@/utils/restClientBuilder';
import { getTraceParent } from '@/utils/restClientBuilder/helpers';

const isLocal = isLocalEnv(getGlobalArgs('NEXT_PUBLIC_ENV', 'local'));

const makeCommonHeadersBuilder = (isLocal: boolean) => () => {
  const baseQueryBuilderHeaders = {};

  if (isLocal) return baseQueryBuilderHeaders;
  return mergeRight(baseQueryBuilderHeaders, { [COMMON_REQUEST_HEADERS.traceParent]: getTraceParent() });
};

const makeInstanceConfig = (isLocal: boolean, baseURL: string) => {
  const namespace = getGlobalArgs('NEXT_PUBLIC_NAMESPACE', '');

  const baseConfig = { baseURL };

  if (isLocal) return baseConfig;

  return mergeRight(baseConfig, { namespace });
};

const commonQueryBuilder = makeQueryBuilder(makeCommonHeadersBuilder(isLocal));

const baseQueryBuilder = makeQueryBuilder();

export const analyticsGatewayV1 = commonQueryBuilder.createInstance(
  makeInstanceConfig(isLocal, `${getGlobalArgs('NEXT_PUBLIC_BACKEND_URL', '')}/analyticsgateway/v1`),
);

export const backendApiInstance = commonQueryBuilder.createInstance(
  makeInstanceConfig(isLocal, `${getGlobalArgs('NEXT_PUBLIC_BACKEND_URL', '')}`),
);

export const selfApiGlossaryInstance = baseQueryBuilder.createInstance({
  baseURL: getGlobalArgs('NEXT_PUBLIC_GLOSSARY_PROXY_URL', ''),
});

export const oidcApiV1 = baseQueryBuilder.createInstance({
  baseURL: `${getGlobalArgs('NEXT_PUBLIC_OIDC_AUTHORITY_URL', '')}/api/v1`,
  withCredentials: true,
});
